import { CSSProperties, ReactNode } from 'react';

import styles from './Text.module.css';

const SIZES = [
  'x-large',
  'large',
  'm-large',
  'medium',
  'm-small',
  'small',
  'x-small',
] as const;

const WEIGHTS = ['bold', 'semi-bold', 'normal'] as const;

type TextProps = {
  children: ReactNode;
  style?: CSSProperties;
  tag?: 'p' | 'span' | 'div' | 'h1' | 'h2' | 'h3' | 'h4';
  weight?: (typeof WEIGHTS)[number];
  size?: (typeof SIZES)[number];
  upperCase?: boolean;
  color?: 'gray' | 'black';
  centered?: boolean;
  onClick?: () => void;
};

const Text = ({
  children,
  tag = 'p',
  style = undefined,
  weight = 'normal',
  size = 'small',
  upperCase = false,
  color = 'black',
  centered = false,
  onClick = () => undefined,
}: TextProps) => {
  const Tag = tag;

  return (
    <Tag
      className={`${styles[weight]} ${styles[size]} ${styles[color]} ${upperCase ? styles.uppercase : ''} ${centered ? styles.centered : ''}`}
      style={style}
      onClick={onClick}
    >
      {children}
    </Tag>
  );
};

export default Text;
